import type { EventSettings } from '@karozik/engine';
import type { EventStatus } from '@karozik/shared';

export interface AdminEvent {
  id: string;
  name: string;
  startsAt: number;
  endsAt: number;
  status: EventStatus;
  joinToken: string;
  kioskToken: string;
  joinUrl: string;
  kioskUrl: string;
  settings: EventSettings;
  poolSize: number;
  guests: number;
  tracksPlayed: number;
}

export const STATUS_LABEL: Record<EventStatus, string> = {
  upcoming: 'À venir',
  live: 'En cours',
  ended: 'Terminée',
};

/** <input type="datetime-local"> value in local time. */
export function toLocalInput(ms: number): string {
  const d = new Date(ms);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
